import { Translate } from '@chipinside/translate'

import { getFarmSlug } from '#/store/ducks/farm'
import { ImportProtocolFieldConfig } from '#/store/hooks/useForms/Import/types/ImportTypeConfig'
import { endpoint } from '#/store/services/endpoints'
import { store } from '#/store/store'

interface IParams {
  protocolField: ImportProtocolFieldConfig
}

export const buildProtocolField = ({ protocolField }: IParams) => ({
  label: Translate({ messageKey: protocolField.labelKey }),
  name: protocolField.name,
  options: [],
  placeholder: Translate({
    messageKey: 'select_one_item_male',
    params: { item: Translate({ lower: true, messageKey: protocolField.labelKey }) },
  }),
  rules: {
    required: {
      message: Translate({
        messageKey: ['required_field', protocolField.labelKey],
        separator: ' - ',
      }),
      value: true,
    },
  },
  source: {
    params: { withDate: true },
    uri: endpoint.farm.protocol.search({ farm: getFarmSlug(store.getState()) }),
  },
  type: 'select',
})
